import { CarouselItemId } from '@homex/se-widget-flow-types';
import { useSelector } from 'react-redux';

import { CarouselContinueButton } from 'components/CarouselContinueButton';
import { Phrase } from 'components/Phrase';
import { CarouselBottomButtonType, IState } from 'typings';

import { Container } from './styles';

export const CAROUSEL_ITEM_ID = CarouselItemId.ConfirmFinishRepair;

export const CarouselItemConfirmFinishRepairBottom = () => {
  const { isStatic } = useSelector((state: IState) => ({
    isStatic: state.client.isStatic,
  }));

  return (
    <Container>
      <CarouselContinueButton
        buttonType={
          isStatic
            ? CarouselBottomButtonType.HOME
            : CarouselBottomButtonType.CLOSE
        }
        label={Phrase({ id: 'CAROUSEL_CONTINUE_BUTTON.SUBMIT' })}
      />
    </Container>
  );
};
